(function(){
  if(window.__nvMotion) return; window.__nvMotion = 1;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('nv-js');
  function revealAll(){
    Array.prototype.forEach.call(document.querySelectorAll('.nv-reveal'), function(el){ el.classList.add('nv-in'); });
  }
  function splitHero(){
    if(rm) return;
    var h = document.querySelector('.nv-bh__h'); if(!h) return;
    var words = [];
    function walk(node, italic){
      Array.prototype.forEach.call(node.childNodes, function(n){
        if(n.nodeType === 3){ n.nodeValue.split(/\s+/).forEach(function(w){ if(w) words.push({ w: w, i: italic }); }); }
        else if(n.nodeType === 1){ walk(n, true); }
      });
    }
    walk(h, false);
    if(!words.length) return;
    h.innerHTML = '';
    words.forEach(function(o, idx){
      var s = document.createElement('span'); s.className = 'nv-w';
      s.style.animationDelay = (120 + idx * 75) + 'ms'; s.textContent = o.w;
      if(o.i){ var e = document.createElement('em'); e.appendChild(s); h.appendChild(e); }
      else { h.appendChild(s); }
      h.appendChild(document.createTextNode(' '));
    });
  }
  function init(){
    try{
      try{ splitHero(); }catch(e){}
      var sels = ['.nv-cl__card','.nv-ing__card','.nv-dp__left','.nv-dp__table','.nv-fo__media','.nv-fo__text','.nv-ri__in > *','.nv-fq__item','.nv-price-card','.nv-shift-item','.nv-band__inner','.nv-pr__cell'];
      var els = Array.prototype.slice.call(document.querySelectorAll(sels.join(',')));
      els.forEach(function(el){ el.classList.add('nv-reveal'); });
      els.forEach(function(el){
        var p = el.parentElement; if(!p) return;
        var sibs = Array.prototype.filter.call(p.children, function(c){ return c.classList && c.classList.contains('nv-reveal'); });
        var i = sibs.indexOf(el);
        if(i > 0) el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
      });
      if(rm || !('IntersectionObserver' in window)){ revealAll(); }
      else {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('nv-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        els.forEach(function(el){ io.observe(el); });
        setTimeout(function(){
          Array.prototype.forEach.call(document.querySelectorAll('.nv-reveal:not(.nv-in)'), function(el){
            var r = el.getBoundingClientRect();
            if(r.top < window.innerHeight && r.bottom > 0) el.classList.add('nv-in');
          });
        }, 1600);
      }
      var amts = document.querySelectorAll('.nv-dp__amt');
      if(amts.length && !rm && 'IntersectionObserver' in window){
        var cio = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(!e.isIntersecting) return; cio.unobserve(e.target);
            var t = e.target.firstChild; if(!t || t.nodeType !== 3) return;
            var m = t.nodeValue.match(/^(\d+)([\s\S]*)$/); if(!m) return;
            var n = parseInt(m[1],10), suf = m[2], st = null;
            t.nodeValue = '0' + suf;
            function step(ts){ if(!st) st = ts; var pr = Math.min((ts-st)/800,1); var ez = 1-Math.pow(1-pr,3); t.nodeValue = Math.round(n*ez) + suf; if(pr<1) requestAnimationFrame(step); }
            requestAnimationFrame(step);
          });
        }, { threshold: 0.4 });
        amts.forEach(function(a){ cio.observe(a); });
      }
      if(rm || window.innerWidth < 750) return;
      document.querySelectorAll('.nv-time').forEach(function(el){ el.setAttribute('data-nv-px','0.05'); });
      var pEls = Array.prototype.slice.call(document.querySelectorAll('[data-nv-px]'));
      if(!pEls.length) return;
      var tick = false;
      function upd(){
        tick = false; var vh = window.innerHeight;
        pEls.forEach(function(el){
          var r = el.getBoundingClientRect();
          if(r.bottom < -260 || r.top > vh + 260) return;
          var sp = parseFloat(el.getAttribute('data-nv-px')) || 0.1;
          var off = (r.top + r.height/2 - vh/2) * sp * -1;
          var tf = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
          if(el.hasAttribute('data-nv-zoom')){
            var prog = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1);
            var sc = (1.08 - 0.08 * prog).toFixed(4);
            tf += ' scale(' + sc + ')';
          }
          el.style.transform = tf;
        });
      }
      window.addEventListener('scroll', function(){ if(!tick){ tick = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }catch(err){ revealAll(); }
  }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();